import { LinkifyExternal } from 'dashboard/components/LinkifyExternal';
import AsyncImage from 'dashboard/components-lib/AsyncImage';

export interface DataDisplayValueProps {
  value: string;
}

const isImageUrl = (value: string): boolean => {
  try {
    const pathname = new URL(value).pathname;

    return pathname.endsWith('.jpeg') || pathname.endsWith('.jpg') || pathname.endsWith('.png');
  } catch {
    return false;
  }
};

const DataDisplayValue = ({ value }: DataDisplayValueProps) => {
  if (isImageUrl(value)) {
    return <AsyncImage value={[{ url: value }]} />;
  }
  return <LinkifyExternal>{value}</LinkifyExternal>;
};

export default DataDisplayValue;
